/**
 * 
 * {
    "descripcion": "Pago de Hotel",
    "meta": null,
    "ejecucion": null,
    "medio_verificacion": null,
    "avances": null,
    "fecha_inicio": null,
    "fecha_final": null,
    "horas_trabajo": null,
    "fk_actividad_id": 102,
    "fk_estado_id": 2
}
 * 
 */

import { useState, useRef, useEffect} from "react"
import { useSelector } from "react-redux"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"

import { TaskPreview } from "../task/task-preview"
import { addTask, updateGroupAction, updatePickerCmpsOrder, addActivity, setDynamicModalObj } from "../../store/board.actions"
import { saveNewSubTask,updateSubActivityOrder } from "../../store/grupo.actions"

import { boardService } from "../../services/board.service"
import { SubTaskPreview } from "../task/subtask-preview"

import { TaskToolsModal } from "../modal/task-tools-modal"
import { TitleGroupPreview } from "./title-group-preview"
import { StatisticGroup } from "./statistics-group"

import { MdKeyboardArrowDown } from 'react-icons/md'
import { BsFillCircleFill } from 'react-icons/bs'
import { BiDotsHorizontalRounded } from 'react-icons/bi'
import { AiOutlinePlus } from 'react-icons/ai'
import{ROLES,userService}from '../../services/user.service'

export function SubItemsPreview ({customHeight, subitems, responsables, group, board, idx, id_actividad}) {
    const grupos = useSelector( (storeState) => storeState.grupoModule.grupos );
    const [totalHoras, setTotalHoras] = useState(0);
    const [subTaskToEdit, setSubTaskToEdit] = useState(boardService.getEmptySubTask())
    // const [UsersToEdit, setUsersEdit] = useState(responsables);
    const [isTyping, setIsTyping] = useState(false)
    const [isShowColorPicker, setIsShowColorPicker] = useState(false)
    const [selectedTasks, setSelectedTasks] = useState([])
    const [isMainCheckbox, setIsMainCheckbox] = useState({ isActive: false })

    const dynamicModalObj = useSelector(storeState => storeState.boardModule.dynamicModalObj)
    // const user = useSelector(storeState => storeState.userModule.user)
    const [user, setUser] = useState(userService.getLoggedinUser().data.data); //Usuario logueado en la interfaz

    const guest = "https://res.cloudinary.com/du63kkxhl/image/upload/v1675013009/guest_f8d60j.png"
    const elMainGroup = useRef()
    const elAddColumn = useRef()
    // const isEditable = user.rol === ROLES.ADMIN;
    const isEditable = user.rol === ROLES.TECNICO || user.rol === ROLES.ADMIN;

    function loadColumns () {
        const columns = board.cmpsOption.filter(cmpOption => {
            return !board.cmpsOrder.includes(cmpOption)
        })
        return columns
    }

    function toggleColumnModal () {
        const columns = loadColumns()
        const isOpen = dynamicModalObj?.group?.id === group.id && dynamicModalObj?.type === 'add-column' ? !dynamicModalObj.isOpen : true
        const { x, y, height } = elAddColumn.current.getClientRects()[0]
        setDynamicModalObj({ isOpen, pos: { x: (x - 225), y: (y + height) }, type: 'add-column', group, columns })
    }

    function handleChange ({ target }) {
        let { value, name: field } = target
        setSubTaskToEdit((prevTask) => ({ ...prevTask, [field]: value }))
    }

    // function onAddTask (ev) {
    //     ev.preventDefault();
    //     if (!subTaskToEdit.descripcion) return

    //     subTaskToEdit.fk_estado_id = 2;
    //     subTaskToEdit.fk_actividad_id = id_actividad;

    //     subTaskToEdit.meta = 1
    //     subTaskToEdit.ejecucion = 0

    //     saveNewSubTask(subTaskToEdit, group.id_grupo, id_actividad);
    //     setSubTaskToEdit(boardService.getEmptySubTask());
    // }

    function onAddTask(ev) {
        ev.preventDefault();
    
        if (!subTaskToEdit.descripcion) return;
    
        let newsubTask = {
            ...subTaskToEdit,
            meta: null,
            ejecucion: null,
            medio_verificacion: null,
            avances: null,
            fecha_inicio:null, 
            fecha_final: null,
            horas_trabajo: null,
            fk_actividad_id: id_actividad,
            fk_estado_id : 1,
            archivada: 0
        };

        // delete newsubTask["id_subactividad"]; 

        
        saveNewSubTask(newsubTask, group.id_grupo, id_actividad)
            .then((savedTask) => {
                setSubTaskToEdit(boardService.getEmptySubTask());
            })
            .catch((err) => {
                console.error('Error al guardar la tarea:', err);
            });
            
    }

    function handleHorizontalDrag (ev) {
        const updatedTitles = [...board.cmpsOrder]
        const [draggedItem] = updatedTitles.splice(ev.source.index, 1)
        updatedTitles.splice(ev.destination.index, 0, draggedItem)
        updatePickerCmpsOrder(board, updatedTitles)
    }

    // async function handleCheckboxChange (task) {
    //     try {
    //         if (selectedTasks.includes(task)) {
    //             console.log("entro aqui cuando es IF")
    //             selectedTasks.splice(selectedTasks.indexOf(task), 1)
    //             setSelectedTasks((selectedTasks) => ([...selectedTasks]))
    //             addCheckActivity(true, task)
    //         } else {
    //             console.log("entro aqui cuando es ELSE")
    //             addCheckActivity(false, task)
    //             setSelectedTasks((prevTasks) => ([...prevTasks, task]))
    //         }
    //     } catch (err) {
    //         console.log('err:', err)
    //     }
    // }

    async function handleCheckboxChange(task) {
        try {
            // Verifica si la subactividad ya está seleccionada utilizando id_subactividad
            const isSelected = selectedTasks.some(selectedTask => selectedTask.id_subactividad === task.id_subactividad);
    
            if (isSelected) {
                // Elimina la subactividad seleccionada filtrando por id_subactividad
                const updatedTasks = selectedTasks.filter(selectedTask => selectedTask.id_subactividad !== task.id_subactividad);
                setSelectedTasks(updatedTasks);
                addCheckActivity(true, task); // Marcar la actividad como deseleccionada
            } else {
                addCheckActivity(false, task); // Marcar la actividad como seleccionada
                setSelectedTasks(prevTasks => [...prevTasks, task]);
            }
        } catch (err) {
            console.log('err:', err);
        }
    }
    

    function onClickMainCheckbox () {
        if (isMainCheckbox.isActive) setSelectedTasks([])
        else setSelectedTasks(group.tasks)
        setIsMainCheckbox({ isActive: !isMainCheckbox.isActive })
    }

    function addCheckActivity (isCheckBoxDown, task) {
        const activity = boardService.getEmptyActivity()
        activity.task = { id: task.id, title: task.title }
        activity.action = 'check'
        activity.from = isCheckBoxDown;
        activity.to = !isCheckBoxDown;
        // addActivity(board, activity)
    }

    const getTotalHoras = () => {
        let totalHorasAcc = 0;

        if (subitems !== undefined) {
            subitems.forEach(subitem => {
    
                if (subitem.horas_trabajo !== null) {
                    totalHorasAcc += parseFloat(subitem.horas_trabajo);
                }
            });

            try {

                setTotalHoras(totalHorasAcc.toFixed(2));
            } catch(ex){
                setTotalHoras(0);
            }

        }

    }


    useEffect(() => {
        getTotalHoras();
    }, []);



    function getAddColumnClassName () {
        return dynamicModalObj.isOpen === true && dynamicModalObj.type === 'add-column' && dynamicModalObj?.group?.id === group.id
    }

    // return <ul className="group-preview flex column" style={{marginLeft: "41px", marginTop:"10px", marginBottom:"30px"}}>

    //     {/* <Draggable key={id_actividad} draggableId={id_actividad + "SUBITEM"} index={idx}>
    //         {(provided) => { */}
    //             {/* return <div ref={provided.innerRef}{...provided.draggableProps}> */}
    //             <div>

    //                 <div className="group-preview-content" >
    //                     {/* Este es el header de cada tabla */}
    //                     {/* <DragDropContext onDragEnd={handleHorizontalDrag}>
    //                         <Droppable droppableId="title" direction="horizontal">
    //                             {(droppableProvided) => { */}
    //                                 {/* return <div ref={droppableProvided.innerRef} {...droppableProvided.droppableProps} className={`title-container flex ${!board.description ? ' not-des' : ''}`} > */}
    //                                 <div className={`title-container flex ${!board.description ? ' not-des' : ''}`} >
    //                                     {/* Checkbox de cada task */}
    //                                     <div className="sticky-div titles flex" style={{ borderColor: group.color }}> 
    //                                         <div className="hidden"style={{ height: '50px',marginTop: '-11px', marginLeft: '-1px', borderTop: '1px solid #d2d6e5', borderLeft: `1px solid ${group.color}` }}></div>
    //                                         <div className="check-box"  >
    //                                             {/* <input type="checkbox" checked={isMainCheckbox.isActive} onChange={onClickMainCheckbox} /> */}
    //                                         </div>
    //                                         <div className="task title" style={{ width:"465px"}}>Tareas</div>
    //                                     </div>

    //                                     {/* {board.cmpsOrder.map((title, idx) => 
    //                                         <Draggable key={title} draggableId={title} index={idx}>
    //                                             {(provided, snapshot) => {
    //                                                 return (
    //                                                     <li ref={provided.innerRef}
    //                                                         {...provided.draggableProps}
    //                                                         {...provided.dragHandleProps} className={title + ' cmp-order-title title'} key={idx}>
    //                                                         <TitleGroupPreview title={title} group={group} board={board} />
    //                                                     </li>
    //                                                 )
    //                                             }}
    //                                         </Draggable>
    //                                     )} */}


    //                                     <div className="tasks flex" style={{ borderColor: group.color }}>
    //                                         <div className="title" style={{ width: "10px" }}>Responsable</div>
    //                                     </div>

    //                                     <div className="tasks flex" style={{ borderColor: group.color }}>
    //                                         <div className="title" style={{ width: "10px" }}>Horas de Trabajo</div>
    //                                     </div>

    //                                     <div className="tasks flex" style={{ borderColor: group.color }}>
    //                                         <div className="title" style={{ width: "10px" }}>Estado</div>
    //                                     </div>

    //                                     <div className="tasks flex" style={{ borderColor: group.color }}>
    //                                         <div className="title" style={{ width: "10px" }}>Fecha de Inicio</div>
    //                                     </div>

    //                                     {/* <div ref={elAddColumn} className="add-picker-task flex align-items" onClick={toggleColumnModal}>
    //                                         <span className={`add-btn ${getAddColumnClassName() ? 'active' : ''}`}>
    //                                             <AiOutlinePlus className={`${getAddColumnClassName() ? 'plus' : 'close'}`} />
    //                                         </span>
    //                                     </div> */}
    //                                 </div>
    //                             {/* }}
    //                         </Droppable>
    //                     </DragDropContext> */}

                        
    //                     {/* Aqui van los items o tasks */}
    //                     {/* <Droppable droppableId={id_actividad + "SUBTASKGROUP"} type='task'> */}
    //                         {/* {(droppableProvided) => ( */}
    //                             {/* <div ref={droppableProvided.innerRef} {...droppableProvided.droppableProps} > */}
    //                             <div>
                               
    //                                  {subitems !== undefined ? subitems.map((task, idx) => (
    //                                     // <Draggable key={id_actividad} draggableId={id_actividad + "SUBITEM2"}  index={idx}>
    //                                         // {(provided) => ( */}
    //                                             // <li ref={provided.innerRef}{...provided.draggableProps} {...provided.dragHandleProps} key={idx}>
    //                                             <li key={task.id_subactividad}>
    //                                                 <SubTaskPreview key={task.id_subactividad} customHeight={customHeight} getHoras={getTotalHoras} task={task} responsables={responsables} group={group} board={board} handleCheckboxChange={handleCheckboxChange} isMainCheckbox={isMainCheckbox} />
    //                                             </li>
    //                                         // {/* )}
    //                                     // </Draggable>
    //                                 )) : null} 

    //                                 {/* {droppableProvided.placeholder} */}


    //                                 {/* Fila para agregar una nueva tarea. */}
    //                                 <div className="add-task titles flex" >
    //                                     <div className="sticky-div" style={{ borderColor: group.color }}>
    //                                     <div className="hidden"style={{ height:'55px', marginLeft: '-1px', borderLeft: `1px solid ${group.color}` }}>
    //                                     <div
    //                                     style={{
    //                                     borderLeft: `1px solid ${group.color}`, // Borde derecho con el color del grupo
    //                                     borderBottom: `1px solid ${group.color}`, // Borde inferior con el color del grupo
    //                                     width: '45px', // Ajusta el ancho del div según sea necesario
    //                                     height: '10px', // Ajusta la altura del div según sea necesario
    //                                     borderBottomLeftRadius: '8px',
    //                                     marginTop: '8px',
    //                                     marginLeft: '-0.5px'
                                       
                                        
    //                                     }}
    //                                 />
                                            
    //                                     </div>
                                            
    //                                         <form onSubmit={onAddTask} className="add-task-form flex align-center">
    //                                             <input type="text"
    //                                                 name="descripcion"
    //                                                 value={subTaskToEdit.descripcion}
    //                                                 placeholder="+ Agregar elemento"
    //                                                 onChange={handleChange}
    //                                                 // onBlur={onAddTask} 
    //                                                 style={{width: "480px", cursor: isEditable ? 'pointer' : 'not-allowed'}}
    //                                                 disabled={!isEditable}
    //                                                 />
    //                                                 {/* <input type="text"
    //                                                 name="meta"
    //                                                 value={subTaskToEdit.meta}
    //                                                 placeholder="+ Agregar Hora"
    //                                                 onChange={handleChange}
    //                                                 style={{ width: "100px" }}
    //                                             />
    //                                             <input type="date"
    //                                                 name="fecha_inicio"
    //                                                 value={subTaskToEdit.fecha_inicio}
    //                                                 onChange={handleChange}
    //                                                 style={{ width: "150px" }}
    //                                             />
    //                                             <input type="date"
    //                                                 name="fecha_final"
    //                                                 value={subTaskToEdit.fecha_final}
    //                                                 onChange={handleChange}
    //                                                 style={{ width: "150px" }}
    //                                             /> */}
    //                                         </form>
    //                                     </div>


    //                                     <div className="empty-div"></div>
    //                                 </div>
                                    
                                    
    //                             </div>
    //                         {/* )}
    //                     </Droppable> */}

    //                     <div className="statistic flex" style={{marginTop:"20px"}}>
    //                         <div className="sticky-container" style={{ width: "540px" }}>
    //                             <div style={{ height:'70px', marginLeft: '5px', borderLeft: `1px solid ${group.color}` }}className="hidden"></div>
    //                         </div>
    //                         <div className="statistic-container flex" style={{marginLeft:"175px"}}>
    //                             <div role="contentinfo" className="statistic-number flex column align-center">

    //                             {/* {subitems !== undefined ? subitems.map((task, idx) => { }) : 0
    //                             } */}

    //                                 <span className="number">{totalHoras}</span>
    //                                 <span className="sum">horas</span>
    //                             </div>
    //                         </div>
    //                         <div className="empty-div"></div>
    //                     </div>

                        


    //                 </div>
    //             </div>
    //         {/* }}
    //     </Draggable> */}
    //     {selectedTasks.length > 0 && <TaskToolsModal board={board} tasks={selectedTasks} group={group} setSelectedTasks={setSelectedTasks} setIsMainCheckbox={setIsMainCheckbox} modalElection = {"SubGroupPreview"} />}
        
    // </ul >




// FUNCION PARA ACTUALIZAR EL ORDEN DE LAS SUBACTIVIDADES
// Función optimizada para manejar el arrastre y la caída
// const handleDragEnd = async (result) => {
//     if (!result.destination) {
//         return; // Si no hay destino, no hacer nada
//     }

//     const { source, destination } = result;

//     // Si la posición no ha cambiado, no hacer nada
//     if (
//         destination.droppableId === source.droppableId &&
//         destination.index === source.index
//     ) {
//         return;
//     }

//     const actividadId = parseInt(source.droppableId.split('-')[1], 10); // Identificar la actividad

//     // Verificar que grupos es un arreglo
//     if (!Array.isArray(grupos)) {
//         console.error("grupos no es un arreglo.", grupos);
//         return; // Salir si no es un arreglo
//     }

//     // Encontrar la actividad con las subactividades que queremos reordenar
//     const actividad = grupos.flatMap(grupo => grupo.actividades).find(actividad => actividad.id_actividad === actividadId);
//     if (!actividad) {
//         console.error("Actividad no encontrada.");
//         return;
//     }

//     // Clonar las subactividades y mover la subactividad a la nueva posición
//     const subactividadesClonadas = Array.from(actividad.subactividades);
//     const [subactividadMovida] = subactividadesClonadas.splice(source.index, 1);
//     subactividadesClonadas.splice(destination.index, 0, subactividadMovida);

//     // Actualizar la posición de cada subactividad
//     const subactividadesActualizadas = subactividadesClonadas.map((subactividad, index) => ({
//         ...subactividad,
//         posicion_elemento: index // Asignar nueva posición
//     }));

//     // Obtener el groupId desde la actividad encontrada
//     const groupId = actividad.fk_grupo_id; 

//     // Llamar a updateSubActivityOrder con el groupId y las subactividades actualizadas
//     await updateSubActivityOrder(actividadId, subactividadesActualizadas, groupId);
// };



// Ordenar las subactividades por posicion_elemento
const sortedSubitems = [...subitems].sort((a, b) => a.posicion_elemento - b.posicion_elemento);



return (
    <>
        <ul className="group-preview flex column" style={{ marginLeft: "41px", marginTop: "10px", marginBottom: "30px" }}>
            <div className="group-preview-content">
                {/* Header de cada tabla */}
                <div className={`title-container flex ${!board.description ? 'not-des' : ''}`}>
                    <div className="sticky-div titles flex" style={{ borderColor: group.color }}>
                        <div className="hidden" style={{ height: '50px', marginTop: '-11px', marginLeft: '-1px', borderTop: '1px solid #d2d6e5', borderLeft: `1px solid ${group.color}` }}></div>
                        <div className="check-box"></div>
                        <div className="task title" style={{ width: "465px" }}>Tareas</div>
                    </div>

                    {/* Títulos de las columnas */}
                    <div className="tasks flex" style={{ borderColor: group.color }}>
                        <div className="title" style={{ width: "10px" }}>Responsable</div>
                    </div>
                    <div className="tasks flex" style={{ borderColor: group.color }}>
                        <div className="title" style={{ width: "10px" }}>Horas de Trabajo</div>
                    </div>
                    <div className="tasks flex" style={{ borderColor: group.color }}>
                        <div className="title" style={{ width: "10px" }}>Estado</div>
                    </div>
                    <div className="tasks flex" style={{ borderColor: group.color }}>
                        <div className="title" style={{ width: "10px" }}>Fecha de Inicio</div>
                    </div>
                </div>

                {/* Lista de Tareas (Subitems) */}

                <Droppable droppableId={`droppable_subtask-${id_actividad}`} type="TASK">
    {(subTaskDroppableProvided) => (
        <div ref={subTaskDroppableProvided.innerRef} {...subTaskDroppableProvided.droppableProps}>
            {subitems
                .slice() // Hacer una copia del array para evitar mutaciones
                .sort((a, b) => a.posicion_elemento - b.posicion_elemento) // Ordenar aquí
                .map((task, subtask_index) => (
                    <Draggable key={`dnd_taskitem-${task.id_subactividad}`} draggableId={`dnd_taskitem-${task.id_subactividad}`} index={subtask_index} type="TASK">
                        {(subitemsProvidedDraggable) => (
                            <li
                                key={task.id_subactividad}
                                ref={subitemsProvidedDraggable.innerRef}
                                {...subitemsProvidedDraggable.draggableProps}
                                {...subitemsProvidedDraggable.dragHandleProps}
                                style={{
                                    ...subitemsProvidedDraggable.draggableProps.style,
                                    listStyle: 'none'
                                }}
                            >
                                <SubTaskPreview
                                    key={task.id_subactividad}
                                    customHeight={customHeight}
                                    getHoras={() => {}}
                                    task={task}
                                    responsables={responsables}
                                    group={group}
                                    board={board}
                                    handleCheckboxChange={handleCheckboxChange}
                                    isMainCheckbox={isMainCheckbox}
                                />
                            </li>
                        )}
                    </Draggable>
                ))}
            {subTaskDroppableProvided.placeholder}
        </div>
    )}
</Droppable>

                {/* Fila para agregar una nueva tarea */}
                <div className="add-task titles flex">
                    <div className="sticky-div" style={{ borderColor: group.color }}>
                        <div className="hidden" style={{ height: '55px', marginLeft: '-1px', borderLeft: `1px solid ${group.color}` }}>
                            <div
                                style={{
                                    borderLeft: `1px solid ${group.color}`,
                                    borderBottom: `1px solid ${group.color}`,
                                    width: '45px',
                                    height: '10px',
                                    borderBottomLeftRadius: '8px',
                                    marginTop: '8px',
                                    marginLeft: '-0.5px'
                                }}
                            />
                        </div>

                        <form onSubmit={onAddTask} className="add-task-form flex align-center">
                            <input
                                type="text"
                                name="descripcion"
                                value={subTaskToEdit.descripcion}
                                placeholder="+ Agregar elemento"
                                onChange={handleChange}
                                style={{ width: "480px", cursor: isEditable ? 'pointer' : 'not-allowed' }}
                                disabled={!isEditable}
                            />
                            {/* Otros campos de entrada pueden agregarse aquí */}
                        </form>
                    </div>
                    <div className="empty-div"></div>
                </div>



                {/* Estadísticas */}
                <div className="statistic flex" style={{ marginTop: "20px" }}>
                    <div className="sticky-container" style={{ width: "540px" }}>
                        <div style={{ height: '70px', marginLeft: '5px', borderLeft: `1px solid ${group.color}` }} className="hidden"></div>
                    </div>
                    <div className="statistic-container flex" style={{ marginLeft: "175px" }}>
                        <div role="contentinfo" className="statistic-number flex column align-center">
                            <span className="number">{totalHoras}</span>
                            <span className="sum">horas</span>
                        </div>
                    </div>
                    <div className="empty-div"></div>
                </div>
            </div>
        </ul>

        {/* Modal de herramientas de tareas seleccionadas */}
        {selectedTasks.length > 0 && (
            <TaskToolsModal
                board={board}
                tasks={selectedTasks}
                group={group}
                setSelectedTasks={setSelectedTasks}
                setIsMainCheckbox={setIsMainCheckbox}
                modalElection={"SubGroupPreview"}
            />
        )}
    </>
);


//verion oficial de pruebas
// return (
//     <DragDropContext onDragEnd={handleDragEnd}>
//         <Droppable droppableId={`droppable-${group.id_grupo}`} type="SUBACTIVITY_TYPE">
//             {(provided) => (
//                 <ul className="group-preview flex column" style={{ marginLeft: "41px", marginTop: "10px", marginBottom: "30px" }} ref={provided.innerRef} {...provided.droppableProps}>
//                     <Draggable key={id_actividad} draggableId={id_actividad + "SUBITEM"} index={idx}>
//                         {(provided) => (
//                             <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
//                                 <div className="group-preview-content">
//                                     {/* Header de la tabla */}
//                                     <div className={`title-container flex ${!board.description ? ' not-des' : ''}`}>
//                                         <div className="sticky-div titles flex" style={{ borderColor: group.color }}>
//                                             <div className="hidden" style={{ height: '50px', marginTop: '-11px', marginLeft: '-1px', borderTop: '1px solid #d2d6e5', borderLeft: `1px solid ${group.color}` }}></div>
//                                             <div className="check-box"></div>
//                                             <div className="task title" style={{ width: "465px" }}>Tareas</div>
//                                         </div>
//                                         <div className="tasks flex" style={{ borderColor: group.color }}>
//                                              <div className="title" style={{ width: "10px" }}>Responsable</div>
//                                          </div>

//                                          <div className="tasks flex" style={{ borderColor: group.color }}>
//                                              <div className="title" style={{ width: "10px" }}>Horas de Trabajo</div>
//                                          </div>

//                                         <div className="tasks flex" style={{ borderColor: group.color }}>
//                                              <div className="title" style={{ width: "10px" }}>Estado</div>
//                                          </div>

//                                          <div className="tasks flex" style={{ borderColor: group.color }}>
//                                              <div className="title" style={{ width: "10px" }}>Fecha de Inicio</div>
//                                          </div>
//                                     </div>
                                    

                                    

//                                     {/* Renderizar subactividades con Drag and Drop */}
//                                     <Droppable droppableId={`SUBTASKGROUP-${id_actividad}`} type="SUBACTIVITY_TYPE">
//                                         {(provided) => (
//                                             <div ref={provided.innerRef} {...provided.droppableProps}>
//                                                 {subitems
//                                                     ? subitems
//                                                         .sort((a, b) => (a.posicion_elemento ?? 0) - (b.posicion_elemento ?? 0)) // Ordenar por posicion_elemento
//                                                         .map((task, idx) => (
//                                                             <Draggable key={task.id_subactividad} draggableId={`SUBTASK-${task.id_subactividad}`} index={idx}>
//                                                                 {(provided) => (
//                                                                     <li
//                                                                         ref={provided.innerRef}
//                                                                         {...provided.draggableProps}
//                                                                         {...provided.dragHandleProps}
//                                                                         key={task.id_subactividad}
//                                                                     >
//                                                                         <SubTaskPreview
//                                                                             key={task.id_subactividad}
//                                                                             customHeight={customHeight}
//                                                                             getHoras={getTotalHoras}
//                                                                             task={task}
//                                                                             responsables={responsables}
//                                                                             group={group}
//                                                                             board={board}
//                                                                             handleCheckboxChange={handleCheckboxChange}
//                                                                             isMainCheckbox={isMainCheckbox}
//                                                                         />
//                                                                     </li>
//                                                                 )}
//                                                             </Draggable>
//                                                         ))
//                                                     : null}
//                                                 {provided.placeholder}

//                                                 {/* Fila para agregar una nueva subactividad */}
//                                                 <div className="add-task titles flex">
//                                                     <div className="sticky-div" style={{ borderColor: group.color }}>
//                                                         <div className="hidden" style={{
//                                                             height: '55px',
//                                                             marginLeft: '-1px',
//                                                             borderLeft: `1px solid ${group.color}`,
//                                                             borderBottom: `1px solid ${group.color}`,
//                                                             width: '45px',
//                                                             height: '10px',
//                                                             borderBottomLeftRadius: '8px',
//                                                             marginTop: '8px',
//                                                             marginLeft: '-0.5px'
//                                                         }} />
//                                                         <form onSubmit={onAddTask} className="add-task-form flex align-center">
//                                                             <input
//                                                                 type="text"
//                                                                 name="descripcion"
//                                                                 value={subTaskToEdit.descripcion}
//                                                                 placeholder="+ Agregar elemento"
//                                                                 onChange={handleChange}
//                                                                 style={{ width: "480px", cursor: isEditable ? 'pointer' : 'not-allowed' }}
//                                                                 disabled={!isEditable}
//                                                             />
//                                                         </form>
//                                                     </div>
//                                                     <div className="empty-div"></div>
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </Droppable>

//                                     {/* Footer de la tabla */}
//                                     <div className="statistic flex" style={{ marginTop: "20px" }}>
//                                         <div className="sticky-container" style={{ width: "540px" }}>
//                                             <div style={{ height: '70px', marginLeft: '5px', borderLeft: `1px solid ${group.color}` }} className="hidden"></div>
//                                         </div>
//                                         <div className="statistic-container flex" style={{ marginLeft: "175px" }}>
//                                             {board.cmpsOrder.map((cmpType, idx) => (
//                                                 <div key={idx} className={`title ${idx === 0 ? ' first ' : ''}${cmpType}`}>
//                                                     <StatisticGroup cmpType={cmpType} board={board} group={group} />
//                                                 </div>
//                                             ))}
//                                         </div>
//                                         <div className="empty-div"></div>
//                                     </div>
//                                 </div>
//                             </div>
//                         )}
//                     </Draggable>
//                     {provided.placeholder}

//                     {/* Modal de herramientas si hay subactividades seleccionadas */}
//                     {selectedTasks.length > 0 && (
//                         <TaskToolsModal
//                             board={board}
//                             tasks={selectedTasks}
//                             group={group}
//                             setSelectedTasks={setSelectedTasks}
//                             setIsMainCheckbox={setIsMainCheckbox}
//                             modalElection={"SubGroupPreview"}
//                         />
//                     )}
//                 </ul>
//             )}
//         </Droppable>
//     </DragDropContext>
// );
}


